<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
            <template v-slot:headerTitle>
                <h4 class="card-title">{{ $t('assitive_device_management.distributed_purchase_order')}}  {{ $t('globalTrans.details') }}</h4>
            </template>
            <template v-slot:headerAction>
                <router-link to="distributed-purchase-order" :class="'btn btn-primary text-light'">{{  $t('assitive_device_management.distributed_purchase_order') }} {{ $t('globalTrans.list') }}</router-link>
                <b-button variant="primary" @click="pdfExport" class="ml-3 mr-2 float-right">
                    {{  $t('globalTrans.export_pdf') }}
                </b-button>
            </template>
          <template v-slot:body>
            <b-overlay :show="loading">
                <b-row>
                    <b-col xl="12" lg="12" sm="12">
                    <list-report-head :base-url="awarenessEventServiceBaseUrl" uri="/configuration/report-heading/detail" :org-id="3">
                              {{ $t('assitive_device_management.distributed_purchase_order')}}  {{ $t('globalTrans.details') }}
                    </list-report-head>
                        <b-row class="mt-2 text-black">
                            <b-col lg="6"  sm="12">
                              <b-row>
                                <b-col sm="4"><strong>{{$t('globalTrans.fiscal_year')}}: </strong></b-col>
                                <b-col style="transform: translateX(-72px);">{{ currentLocale === 'en' ? formData.fiscal_year_en : formData.fiscal_year_bn }}</b-col>
                              </b-row>
                            </b-col>
                            <b-col lg="6"  sm="12" style="transform: translateX(190px);">
                              <b-row>
                                <b-col sm="4"><strong>{{$t('assitive_device_management.purchase_order_no')}}: </strong></b-col>
                                <b-col style="transform: translateX(-19px);">{{ $n(formData.purchase_memo_no, { useGrouping: false }) }}</b-col>
                              </b-row>
                            </b-col>
                        </b-row>
                        <hr>
                        <b-row>
                            <b-col lg="12" sm="12">
                                <b-table-simple responsive bordered small v-if="deviceList.length">
                                    <thead>
                                        <tr>
                                            <th width="8%" rowspan="2">{{ $t('globalTrans.sl_no') }}</th>
                                            <th class="text-center" rowspan="2" width="20%">{{ $t('assitive_device_management.idsc_center') }}</th>
                                            <th class="text-center" :colspan="deviceList.length">{{ $t('assitive_device_management.assign_quantity') }}</th>
                                        </tr>
                                        <tr>
                                            <th class="text-center" v-for ="(info, index) in deviceList" :key="index" :width="(72/deviceList.length)+'%'">
                                              {{ ($i18n.locale == 'bn' ? info.device_name_bn : info.device_name) }}<br>
                                              {{ $t('sitePreference.total') }}: {{ $n(deviceTotalQuantity[info.assistive_device_id]) }}<br>
                                              {{ $t('assitive_device_management.remaining') }}: {{ $n(deviceRemainingQuantity[info.assistive_device_id]) }}
                                            </th>
                                        </tr>
                                    </thead>
                                    <b-tbody>
                                          <b-tr v-for="(center, centerIndex) in formData.centers" :key="centerIndex">
                                              <b-td>
                                                  {{ $n(centerIndex + 1) }}
                                              </b-td>
                                              <b-td>
                                                {{ currentLocale === 'en' ? center.center_name : center.center_name_bn }}
                                              </b-td>
                                              <td class="text-center" v-for ="(device, deviceIndex) in center.devices" :key="deviceIndex" >
                                                  {{ device.quantity ? $n(device.quantity) : '' }}
                                              </td>
                                          </b-tr>
                                    </b-tbody>
                                </b-table-simple>
                                <template v-else>
                                    <div class="text-center text-black">
                                        {{ $t('globalTrans.noDataFound') }}
                                    </div>
                                </template>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import RestApi, { awarenessEventServiceBaseUrl } from '@/config/api_config'
import { distPurOrderStore, distPurOrderUpdate, distPurOrderShow, purchaseMemoWiseDeviceName } from '../../api/routes'
import flatpickr from 'flatpickr'
import ListReportHead from '@/components/custom/ListReportHeadAwareness.vue'
import ExportPdf from './export-pdf_details'

export default {
    name: 'FormLayout',
    props: ['id'],
    components: {
        ListReportHead
    },
    created () {
        // this.getPurchaseMemoList()
        if (this.$route.query.id) {
            this.getFormData()
        }
        if (this.$store.state.dataFilters.officeId) {
          const centerOfficeId = this.$store.state.dataFilters.officeId
          this.activeCenter = this.idscCenterList.find(item => item.office_id === parseInt(centerOfficeId))
        }
    },
    mounted () {
        core.index()
        flatpickr('.budgetDate', {})
    },
    data () {
        return {
          saveBtnName: this.$route.query.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
          loader: false,
          formData: {
              fiscal_year_id: 0,
              purchase_memo_no: 0,
              centers: [],
              fiscal_year_en: '',
              fiscal_year_bn: ''
          },
          awarenessEventServiceBaseUrl: awarenessEventServiceBaseUrl,
          purchaseMemoList: [],
          purchaseMemoListAll: [],
          deviceList: [],
          totalQuantity: 0,
          remainingQuantity: 0,
          deviceTotalQuantity: {},
          deviceRemainingQuantity: {},
          formDataExists: {
            fiscal_year_id: 0,
            purchase_memo_no: 0,
            centers: []
          },
          activeCenter: {
            value: 0
          }
        }
    },
    computed: {
      loading () {
          return this.$store.state.commonObj.loading
      },
      fiscalYearList: function () {
          return this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
      },
      assistiveDeviceList: function () {
          return this.$store.state.AwarenessEventService.commonObj.assistiveDeviceList.filter(item => item.status === 1)
      },
      idscCenterList: function () {
        return this.$store.state.AwarenessEventService.commonObj.idscCenterList.filter(item => item.status === 1 && item.org_id === 3 && item.sales_center_type === 1)
      },
      currentLocale () {
          return this.$i18n.locale
      }
    },
    watch: {
      'formData.fiscal_year_id': function (newVal) {
        this.purchaseMemoList = this.getMemoList(newVal)
      }
    },
    methods: {
        pdfExport () {
          const reportTitle = this.$t('assitive_device_management.distributed_purchase_order') + ' ' + this.$t('globalTrans.details')
          // ExportPdf.exportPdfDetails(awarenessEventServiceBaseUrl, '/configuration/report-heading/detail', 3, reportTitle, this.detailData, this, this.getDisabilityTypeNameList, this.getStatus, this.awarenessEventServiceBaseUrl)
          ExportPdf.exportPdfDetails(reportTitle, this.formData, this, this.awarenessEventServiceBaseUrl, awarenessEventServiceBaseUrl, '/configuration/report-heading/detail', 3, this.deviceList, this.deviceRemainingQuantity, this.formData.centers)
        },
        async getFormData () {
          this.$store.dispatch('mutateCommonProperties', { loading: true })
          const result = await RestApi.getData(awarenessEventServiceBaseUrl, distPurOrderShow + '/' + this.$route.query.id)
          if (result.success) {
            this.formDataExists = result.data
            this.formData.id = this.formDataExists.id
            this.formData.purchase_memo_no = this.formDataExists.purchase_memo_no
            this.formData.fiscal_year_id = this.formDataExists.fiscal_year_id
            const fiscalYear = this.fiscalYearList.find(item => item.value === this.formData.fiscal_year_id)
            this.formData.fiscal_year_en = fiscalYear?.text_en
            this.formData.fiscal_year_bn = fiscalYear?.text_bn
            this.getCenterAndAssistiveDevice()
          } else {
            this.$store.dispatch('mutateCommonProperties', { loading: false })
          }
        },
        async storeUpdate () {
            this.loader = true
            this.$store.dispatch('mutateCommonProperties', { loading: true })
            let result = null
            const loadinState = { loading: false, listReload: true }

            if (this.$route.query.id) {
                result = await RestApi.putData(awarenessEventServiceBaseUrl, `${distPurOrderUpdate}/${this.$route.query.id}`, this.formData)
            } else {
                result = await RestApi.postData(awarenessEventServiceBaseUrl, distPurOrderStore, this.formData)
            }

            if (result.success) {
                this.$store.dispatch('mutateCommonProperties', loadinState)
                this.loader = false
                this.$store.dispatch('AwarenessEventService/mutateCommonObj', { hasDropdownLoaded: false })
                this.$toast.success({
                  title: this.$t('globalTrans.success'),
                  message: this.$route.query.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
                  color: '#D6E09B'
                })

                this.$router.push('/awareness-event-service/assistive-device-management/distributed-purchase-order')
            } else {
              this.loader = false
              this.$refs.form.setErrors(result.errors)
              this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
            }
        },
        async getCenterAndAssistiveDevice () {
          this.$store.dispatch('mutateCommonProperties', { loading: true })
            const searchParams = {
                fiscal_year_id: this.formData.fiscal_year_id,
                purchase_memo_no: this.formData.purchase_memo_no
            }
            this.loader = true
            const result = await RestApi.getData(awarenessEventServiceBaseUrl, purchaseMemoWiseDeviceName, searchParams)
            if (result.success) {
                this.deviceList = this.getRelationalData(result.data)
                this.formData.centers = []
                let centerList
                if (this.activeCenter.value) {
                  centerList = this.idscCenterList.filter(item => item.value === this.activeCenter.value)
                } else {
                  centerList = this.idscCenterList
                }
                centerList.forEach((centerItem, centerIndex) => {
                    const center = this.formDataExists.centers.find(obj => obj.idsc_center_id === parseInt(centerItem.value))
                    const devices = []
                    this.deviceList.forEach((deviceItem, deviceIndex) => {
                      const device = center?.devices.find(obj => obj.assistive_device_id === deviceItem.assistive_device_id)
                      devices.push({
                        assistive_device_id: deviceItem.assistive_device_id,
                        quantity: device !== undefined ? device.quantity : ''
                      })
                      if (device !== undefined) {
                        this.setRemainingQuantity(centerIndex, deviceIndex)
                      }
                      this.deviceTotalQuantity[deviceItem.assistive_device_id] = deviceItem.purchase_quantity
                      this.$set(this.deviceRemainingQuantity, deviceItem.assistive_device_id, deviceItem.purchase_quantity)
                    })
                    this.formData.centers.push({
                        idsc_center_id: centerItem.value,
                        center_name: centerItem.text_en,
                        center_name_bn: centerItem.text_bn,
                        devices: devices
                    })
                })
              this.$store.dispatch('mutateCommonProperties', { loading: false })
            } else {
              this.$store.dispatch('mutateCommonProperties', { loading: false })
            }
            this.loader = false
        },
        getRelationalData (data) {
          let totalQuantity = 0
          const listData = data.map(item => {
            const assistiveDevice = this.$store.state.AwarenessEventService.commonObj.assistiveDeviceList.find(device => device.value === item.assistive_device_id)
            const list = {
                device_name: assistiveDevice !== undefined ? assistiveDevice.text_en : '',
                device_name_bn: assistiveDevice !== undefined ? assistiveDevice.text_bn : ''
            }
            totalQuantity += item.purchase_quantity
            return Object.assign({}, item, list)
          })
          this.totalQuantity = totalQuantity
          return listData
        },
        getMemoList (fiscalYearId = null) {
          let purchaseMemoList = this.purchaseMemoListAll
          if (fiscalYearId) {
            purchaseMemoList = purchaseMemoList.filter(item => item.fiscal_year_id === parseInt(fiscalYearId))
          }
          return purchaseMemoList
        },
        isNumber: function (evt) {
          if (evt === 'undefined' || evt === null) {
            evt = window.event
          }
          var charCode = (evt.which) ? evt.which : evt.keyCode
          if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
            evt.preventDefault()
          } else {
            return true
          }
        },
        setRemainingQuantity (centerIndex, deviceIndex) {
          this.$nextTick(() => {
            const device = this.formData.centers[centerIndex].devices[deviceIndex]
            const totalDeviceQuantity = this.getTotalDeviceQuantity(device)
            const totalRemainingQuantity = this.deviceTotalQuantity[device.assistive_device_id] - totalDeviceQuantity
            this.$set(this.deviceRemainingQuantity, device.assistive_device_id, totalRemainingQuantity)
            if (totalDeviceQuantity > this.deviceTotalQuantity[device.assistive_device_id]) {
              device.quantity = this.deviceTotalQuantity[device.assistive_device_id] - (totalDeviceQuantity - device.quantity)
              this.$toast.error({
                title: 'error',
                message: 'Total device quantity can not be larger than total quantity',
                color: '#D6E09B'
              })
            }
            return this.calculateRemainingQuantity(device)
          })
        },
        calculateRemainingQuantity (device) {
          const totalDeviceQuantity = this.getTotalDeviceQuantity(device)
          this.deviceRemainingQuantity[device.assistive_device_id] = this.deviceTotalQuantity[device.assistive_device_id] - totalDeviceQuantity
        },
        getTotalDeviceQuantity (device) {
          let totalDeviceQuantity = 0
          this.formData.centers.forEach(center => {
            center.devices.forEach(deviceItem => {
              if (device.assistive_device_id === deviceItem.assistive_device_id) {
                totalDeviceQuantity += deviceItem.quantity ? parseFloat(deviceItem.quantity) : 0
              }
            })
          })
          return totalDeviceQuantity
        }
    }
}
</script>
